import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import PageLink from 'models/PageLink';

import Link from 'next/link';
import Wrapper from './styled/Wrapper';
import StyledLink from './styled/Link';

export default class FooterLink extends PureComponent {


  static defaultProps = {
    isBack: false,
  };

  static contextType = ThemeContext;

  render() {
    const { className, name, url, isBack, dark, onClick } = this.props;

    return (
      <Wrapper className={className}>
        <Link href={url} passHref>
          <StyledLink theme={this.context} isBack={isBack} dark={dark} onClick={onClick}>
            {name}
          </StyledLink>
        </Link>
      </Wrapper>
    );
  }
}
